import ModalSelect from '../grupos/surfaces/modal';

export default ModalSelect;